import React from 'react'
import styles from '../../styles'
import { makeStyles } from '@material-ui/core/styles'
import EnhancedProfileMenu from '../../modules/profile/ProfileMenu'
import classNames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import useTheme from '@material-ui/core/styles/useTheme'
import { ClassValue } from 'classnames/types'
import languages from '../../enums/languagesEnum'
import links from '../../enums/linksEnum'
import SvgHandicap from '../../icons/Handicap'
import { ButtonBase } from '@material-ui/core'
import { AccessibilityModel } from '../../types/accessibility/accessibilityModel'
import { RootState } from '../../modules/reducers'
import { connect } from 'react-redux'
import { saveAccessibility } from '../../modules/reducers/accessibility/actions'
import portals from '../../enums/portalsEnum'

const useStyles = makeStyles(theme => {
	return {
		...styles(theme),
		lineHeight: {
			height: '100%',
			flexWrap: 'nowrap',

			'& p': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				position: 'relative',
				height: '100%',
				margin: '0px',
				boxSizing: 'border-box'
			}
		},
		menuStyle: {
			marginRight: '40px',

			'&:first-child': {
				marginLeft: '55px'
			},
			'&:hover': {
				color: theme.palette.dynamic.main
			}
		},
		profileStyle: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-end',
			paddingRight: '40px'
		},
		langStyle: {
			whiteSpace: 'nowrap',

			'& span': {
				cursor: 'pointer',
				color: theme.palette.blue['30'],
				textTransform: 'uppercase'
			},
			'& span:first-child': {
				marginRight: '5px'
			},
			'& span:last-child': {
				marginLeft: '5px'
			}
		},
		selectedLang: {
			color: theme.palette.blue.main + ' !important'
		},
		questionMenuStyle: {
			whiteSpace: 'nowrap'
		}
	}
})

interface AcceptingProps {
	onClick: (link: string) => void,
	locale: string,
	changeLang: (ln: string) => void,
	linkIsSelected: (linksArray: string[], link: string) => string,
}

interface Store {
	accessibility: AccessibilityModel,
	saveAccessibility: (accessibilityData: AccessibilityModel) => void,
}

type MenuLargeScreenProps =
	AcceptingProps
	& RouteComponentProps
	& Store

const MenuLargeScreen: React.FC<MenuLargeScreenProps> = (
	{
		location,
		onClick,
		locale,
		changeLang,
		linkIsSelected,
		saveAccessibility,
		accessibility
	}
) => {
	const theme = useTheme()
	const classes = useStyles(theme)
	const intl = useIntl()

	const link = location.pathname
	const linksDashboard: string[] = [links.dashboard]
	const linksNews: string[] = [links.news]
	const linksServices: string[] = [links.services]
	const linksContracts: string[] = [links.contracts]
	const linksRequests: string[] = [links.requests, links.formulaireChangementAppartement]
	const linksQuestions: string[] = [links.questions]

	const linksClass: ClassValue = classNames(
		'row',
		classes.lineHeight
	)
	const linkClass: ClassValue = classNames(
		classes.menuStyle,
		classes.cursorPointer
	)
	const profileClass: ClassValue = classNames(
		'col-sm-2 col-lg-3 col-xl-4',
		classes.profileStyle
	)
	const langClass: ClassValue = classNames(
		classes.text4,
		classes.langStyle
	)
	const questionMenuClass: ClassValue = classNames(
		classes.title5,
		classes.questionMenuStyle
	)
	const buttonClass: ClassValue = classNames(
		accessibility.isVisualHandicap ? [classes.backgroundBlue] : [classes.backgroundWhite]
	)

	const handleHandicap = () => {
		saveAccessibility({
			isVisualHandicap: !accessibility.isVisualHandicap
		})
	}

	return (
		<>
			<div
				className="col-sm-8 col-lg-7 col-xl-6"
			>
				<div
					className={linksClass}
				>
					<div
						className={linkClass}
						onClick={() => onClick(links.dashboard)}
					>
						<p
							className={classes.title5}
						>
							<span
								className={linkIsSelected(linksDashboard, link)}
							>
								<FormattedMessage
									id="menu.dashboard"
									defaultMessage="Tableau de bord"
									description="Dashboard text"
								/>
							</span>
						</p>
					</div>

					<div
						className={linkClass}
						onClick={() => onClick(links.news)}
					>
						<p
							className={classes.title5}
						>
							<span
								className={linkIsSelected(linksNews, link)}
							>
								<FormattedMessage
									id="menu.news"
									defaultMessage="Actualités"
									description="News text"
								/>
							</span>
						</p>
					</div>

					{
						process.env.REACT_APP_TARGET === portals.campus &&
							<div
								className={linkClass}
								onClick={() => onClick(links.services)}
							>
								<p
									className={classes.title5}
								>
									<span
										className={linkIsSelected(linksServices, link)}
									>
										<FormattedMessage
											id="menu.services"
											defaultMessage="Services"
											description="Services text"
										/>
									</span>
								</p>
							</div>
					}

					<div
						className={linkClass}
						onClick={() => onClick(links.contracts)}
					>
						<p
							className={classes.title5}
						>
							<span
								className={linkIsSelected(linksContracts, link)}
							>
								<FormattedMessage
									id="menu.contracts"
									defaultMessage="Votre compte"
									description="Your account text"
								/>
							</span>
						</p>
					</div>

					<div
						className={linkClass}
						onClick={() => onClick(links.requests)}
					>
						<p
							className={classes.title5}
						>
							<span
								className={linkIsSelected(linksRequests, link)}
							>
								<FormattedMessage
									id="menu.requests"
									defaultMessage="Vos demandes"
									description="Requests text"
								/>
							</span>
						</p>
					</div>

					<div
						className={linkClass}
						onClick={() => onClick(links.questions)}
					>
						<p
							className={questionMenuClass}
						>
							<span
								className={linkIsSelected(linksQuestions, link)}
							>
								<FormattedMessage
									id="menu.questions"
									defaultMessage="Questions ?"
									description="Questions text"
								/>
							</span>
						</p>
					</div>
				</div>
			</div>

			<div
				className={profileClass}
			>
				<ButtonBase className={buttonClass} onClick={handleHandicap}>
					<SvgHandicap
						color={accessibility.isVisualHandicap ? 'white' : theme.palette.blue.main}
						title={intl.formatMessage(
							{
								id: `menu.accessibility.title.${accessibility.isVisualHandicap ? 'disableVisualHandicap' : 'enableVisualHandicap'}`,
								defaultMessage: 'Consulter la version e-accessible',
								description: 'SVG title'
							}
						)}
						description={intl.formatMessage(
							{
								id: `menu.accessibility.title.${accessibility.isVisualHandicap ? 'disableVisualHandicap' : 'enableVisualHandicap'}`,
								defaultMessage: 'Consulter la version e-accessible',
								description: 'SVG description'
							}
						)}
					/>
				</ButtonBase>
				<EnhancedProfileMenu
					onClick={onClick}
					locale={locale}
				/>

				<span className={langClass}>
					{
						Object.keys(languages).map(
							(language, index) => (
								<React.Fragment key={index}>
									<span
										onClick={() => changeLang(language)}
										className={locale === language ? classes.selectedLang : ''}
									>
										{language}
									</span>
									{index < Object.keys(languages).length - 1 ? '|' : ''}
								</React.Fragment>
							)
						)
					}
				</span>
			</div>
		</>
	)
}

const mapStateToProps = (state: RootState) => (
	{
		accessibility: state.accessibility
	}
)

const mapDispatchToProps = {
	saveAccessibility
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MenuLargeScreen))
